import axios from "axios";
import store from "./vuex/store";

export default {

  login(credential) {
    return axios.post("/login", credential);
  },
  login_office(credential) {
    return axios.post("/login_office", credential);
  },
  register(params) {
    return axios.post("/register", params);
  },

  getProfile(username) {
    return axios.get(`/getProfile/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },





  // report

  getAllReport() {
    return axios.get(`/setting/getAllReport`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  reportDetail(id) {
    return axios.get(`/setting/reportDetail/${id}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  dasmReport(year, branchid) {
    return axios.get(`/setting/dasmReport/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPlanProvinceList(year) {
    return axios.get(`/setting/getPlanProvinceList/${year}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPlanOfYear(branchid) {
    return axios.get(`/setting/getPlanOfYear/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  yearPlanDetail(year, branchid) {
    return axios.get(`/setting/yearPlanDetail/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveDasmPlan(params) {
    return axios.post(`/setting/saveDasmPlan`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  dppReport(year, branchid) {
    return axios.get(`/setting/dppReport/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveDPPPlan(params) {
    return axios.post(`/setting/saveDPPPlan`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPlanDPPProvinceList(year) {
    return axios.get(`/setting/getPlanDPPProvinceList/${year}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDPPPlanOfYear(branchid) {
    return axios.get(`/setting/getDPPPlanOfYear/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  yearDDPPlanDetail(year, branchid) {
    return axios.get(`/setting/yearDDPPlanDetail/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getPlanMarketProvinceList(year) {
    return axios.get(`/setting/getPlanMarketProvinceList/${year}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveMarketPlan(params) {
    return axios.post(`/setting/saveMarketPlan`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getMarketPlanOfYear(branchid) {
    return axios.get(`/setting/getMarketPlanOfYear/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  yearMarketPlanDetail(year, branchid) {
    return axios.get(`/setting/yearMarketPlanDetail/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  marketReport(year, branchid) {
    return axios.get(`/setting/marketReport/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getPlanSaleProvinceList(year) {
    return axios.get(`/setting/getPlanSaleProvinceList/${year}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveSalePlan(params) {
    return axios.post(`/setting/saveSalePlan`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getSalePlanOfYear(branchid) {
    return axios.get(`/setting/getSalePlanOfYear/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  yearSalePlanDetail(year, branchid) {
    return axios.get(`/setting/yearSalePlanDetail/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saleReport(year, branchid) {
    return axios.get(`/setting/saleReport/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  cancelB2BFormProduct(params) {
    return axios.post(`/dasm/cancelB2BFormProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },



  internstudentregister(params) {
    return axios.post("/internstudentregister", params);
  },

  // dpp
  saveBranch(params) {
    return axios.post(`/setting/saveBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getBranches() {
    return axios.get(`/setting/getBranches`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateBranch(params) {
    return axios.post(`/setting/updateBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  changeBranchSataus(params) {
    return axios.post(`/setting/changeBranchSataus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getCountry() {
    return axios.get(`/setting/getCountry`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getResponseUser(roleid) {
    return axios.get(`/setting/getResponseUser/${roleid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getProvincebyCountry(country) {
    return axios.get(`/setting/getProvincebyCountry/${country}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDistrict(provinceid) {
    return axios.get(`/setting/getDistrict/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getAllProvince() {
    return axios.get(`/setting/getAllProvince`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppProvince() {
    return axios.get(`/setting/getDppProvince`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getStockList(username) {
    return axios.get(`/setting/getStockList/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  addProvinceToBranch(params) {
    return axios.post(`/setting/addProvinceToBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppUser() {
    return axios.get(`/setting/getDppUser`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveDppUser(params) {
    return axios.post(`/setting/saveDppUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  updateDppUser(params) {
    return axios.post(`/setting/updateDppUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  changeUserStatus(params) {
    return axios.post(`/setting/changeUserStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateByUserRequest(params) {
    return axios.post(`/user/updateByUserRequest`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  

  // rider 
  getRiderUsers(marketid) {
    return axios.get(`/setting/getRiderUsers/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // 

  getGroupZone(provinceid) {
    return axios.get(`/setting/getGroupZone/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getGroupFarmList(provinceid, groupid) {
    return axios.get(`/setting/getGroupFarmList/${provinceid}/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getFarmerUsers(provinceid) {
    return axios.get(`/setting/getFarmerUsers/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  searchFarmerUsers(params) {
    return axios.post(`/setting/searchFarmerUsers`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  saveFarmer(params) {
    return axios.post(`/setting/saveFarmer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateFarmer(params) {
    return axios.post(`/setting/updateFarmer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeFarmerStatus(params) {
    return axios.post(`/setting/changeFarmerStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  apporveAllFarmer(params) {
    return axios.post(`/setting/apporveAllFarmer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  changeRiderStatus(params) {
    return axios.post(`/setting/changeRiderStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getContractforDpp(status) {
    return axios.get(`/dpp/getContractforDpp/${status}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getYearList() {
    return axios.get(`/setting/getYearList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getActivePlanYear() {
    return axios.get(`/setting/getActivePlanYear`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppOAFarmList(provinceid) {
    return axios.get(`/dpp/getDppOAFarmList/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getOAICSRecordForm() {
    return axios.get(`/dpp/getOAICSRecordForm`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveOAICS(params) {
    return axios.post(`/dpp/saveOAICS`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  //dasm
  getBranchesofsalemarketing() {
    return axios.get(`/setting/getBranchesofsalemarketing`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeBranchSaleMarketSataus(params) {
    return axios.post(`/setting/changeBranchSaleMarketSataus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveBranchofSaleMarketing(params) {
    return axios.post(`/setting/saveBranchofSaleMarketing`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateDasmBranch(params) {
    return axios.post(`/setting/updateDasmBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveDasmUser(params) {
    return axios.post(`/setting/saveDasmUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDasmUser() {
    return axios.get(`/setting/getDasmUser`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeUserDasmStatus(params) {
    return axios.post(`/setting/changeUserDasmStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateDasmUser(params) {
    return axios.post(`/setting/updateDasmUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getResponseDasmUser(roleid) {
    return axios.get(`/setting/getResponseDasmUser/${roleid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  saveDasmPaymentForm(params) {
    return axios.post(`/dasm/saveDasmPaymentForm`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getDASMPaymentRequest(branchid) {
    return axios.get(`/dasm/getDASMPaymentRequest/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getB2BContractList(branchid) {
    return axios.get(`/dasm/getB2BContractList/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  createB2BReceipt(params) {
    return axios.post(`/dasm/createB2BReceipt`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeB2BReceiptStatus(params) {
    return axios.post(`/dasm/changeB2BReceiptStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getB2BProvince() {
    return axios.get(`/dpp/getB2BProvince`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getB2BList(provniceid) {
    return axios.get(`/dpp/getB2BList/${provniceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getContractList(provniceid, b2busername) {
    return axios.get(`/dpp/getContractList/${provniceid}/${b2busername}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getSubContract(provniceid, b2busername, contractno) {
    return axios.get(`/dpp/getSubContract/${provniceid}/${b2busername}/${contractno}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getSubContractbyProduceProvinceAndProduct(provniceid, b2busername, contractno, produceprovinceid, productid) {
    return axios.get(`/dpp/getSubContractbyProduceProvinceAndProduct/${provniceid}/${b2busername}/${contractno}/${produceprovinceid}/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // getSubContractbyProduct(provniceid,b2busername, contractno, productid){
  //   return axios.get(`/dpp/getSubContractbyProduct/${provniceid}/${b2busername}/${contractno}/${productid}`, {
  //     headers: { Authorization: "Bearer " + store.getters.getJwt }
  //   });
  // },





  getContractProductProvince(year, status) {
    return axios.get(`/dpp/getContractProductProvince/${year}/${status}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppContractProductList(contractid) {
    return axios.get(`/dpp/getDppContractProductList/${contractid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },




  getDppContractProductListBranch(year, branchid) {
    return axios.get(`/dpp/getDppContractProductListBranch/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppContractProductWait(year, branchid) {
    return axios.get(`/dpp/getDppContractProductWait/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppContractProductWaitFarmer(requestid) {
    return axios.get(`/dpp/getDppContractProductWaitFarmer/${requestid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppContractProductAllFarmer(provinceid, requestid) {
    return axios.get(`/dpp/getDppContractProductAllFarmer/${provinceid}/${requestid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppContractProductPlanFarmer(requestid) {
    return axios.get(`/dpp/getDppContractProductPlanFarmer/${requestid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getDppContractProductAssigned(year, branchid) {
    return axios.get(`/dpp/getDppContractProductAssigned/${year}/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  branchRevievePlan(params) {
    return axios.post(`/dpp/branchRevievePlan`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  branchSendBackPlan(params) {
    return axios.post(`/dpp/branchSendBackPlan `, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  cancelBranchRevievePlan(params) {
    return axios.post(`/dpp/cancelBranchRevievePlan`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  branchRevievePlans(params) {
    return axios.post(`/dpp/branchRevievePlans`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getTransportationInfo(productionid) {
    return axios.get(`/dpp/getTransportationInfo/${productionid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveTransportation(params) {
    return axios.post(`/dpp/saveTransportation`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  sendContractPlanToBranch(params) {
    return axios.post(`/dpp/sendContractPlanToBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  checkAllContractProductSendtoBranch(params) {
    return axios.post(`/dpp/checkAllContractProductSendtoBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clearContractPlanFromBranch(params) {
    return axios.post(`/dpp/clearContractPlanFromBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  actionToContractPlanForFarmer(params) {
    return axios.post(`/dpp/actionToContractPlanForFarmer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProvinceofBranch(branchid) {
    return axios.get(`/dpp/getProvinceofBranch/${branchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getFarmerList(provinceid) {
    return axios.get(`/dpp/getFarmerList/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getB2BInterestedFarmerList(B2BID) {
    return axios.get(`/dpp/getB2BInterestedFarmerList/${B2BID}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getFarmerProductionList(provinceid, redate) {
    return axios.get(`/dpp/getFarmerProductionList/${provinceid}/${redate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getFarmList(farmerid) {
    return axios.get(`/dpp/getFarmList/${farmerid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  setContractPlanForFarmer(params) {
    return axios.post(`/dpp/setContractPlanForFarmer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDppBranchProvinceList(branch, year) {
    return axios.get(`/dpp/getDppBranchProvinceList/${branch}/${year}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getDppBranchProvinceFarmList(province, year) {
    return axios.get(`/dpp/getDppBranchProvinceFarmList/${province}/${year}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getDppBranchProvinceFarmProductList(farmid, year) {
    return axios.get(`/dpp/getDppBranchProvinceFarmProductList/${farmid}/${year}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  setMarketPlanForFarmer(params) {
    return axios.post(`/dpp/setMarketPlanForFarmer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveB2bUser(params) {
    return axios.post(`/setting/saveB2bUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getB2bUser(username) {
    return axios.get(`/setting/getB2bUser/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getB2bUserByStatus(username) {
    return axios.get(`/setting/getB2bUserByStatus/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getSubB2B(username) {
    return axios.get(`/setting/getSubB2B/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveSubB2B(params) {
    return axios.post(`/setting/saveSubB2B`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  updateSubB2B(params) {
    return axios.post(`/setting/updateSubB2B`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getDASMB2bUser(username, type) {
    return axios.get(`/setting/getDASMB2bUser/${username}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getDASMWaiterB2bUser() {
    return axios.get(`/setting/getDASMWaiterB2bUser`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  

  getDASMB2bUserForCustomer() {
    return axios.get(`/setting/getDASMB2bUserForCustomer`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  

  

  saveContract(params) {
    return axios.post(`/dasm/saveContract`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getContractByB2bUser(b2busername, type) {
    return axios.get(`/dasm/getContractByB2bUser/${b2busername}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  saveB2BQuotaProductAmount(params) {
    return axios.post(`/dasm/saveB2BQuotaProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  

  createNewContract(params) {
    return axios.post(`/dasm/createNewContract`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelB2BPrepareProduct(params) {
    return axios.post(`/dasm/cancelB2BPrepareProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveCustomerPO(params) {
    return axios.post(`/dasm/saveCustomerPO`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelB2BQuotationProduct(params) {
    return axios.post(`/dasm/cancelB2BQuotationProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  submitB2BProductsAmount(params) {
    return axios.post(`/dasm/submitB2BProductsAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  editB2BPrepareProduct(params) {
    return axios.post(`/dasm/editB2BPrepareProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  editB2BOrderNumber(params) {
    return axios.post(`/dasm/editB2BOrderNumber`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  editB2BQuotationProduct(params) {
    return axios.post(`/dasm/editB2BQuotationProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // start account system

  sendKangHuptoAccount(params) {
    return axios.post(`/dasm/sendKangHuptoAccount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  sendInvoice(params) {
    return axios.post(`/dasm/sendInvoice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  sendKangHuptoAccountByBatch(params) {
    return axios.post(`/dasm/sendKangHuptoAccountByBatch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  //end account system

  editB2BInvoiceProduct(params) {
    return axios.post(`/dasm/editB2BInvoiceProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  lockNewB2BProductPrice(params) {
    return axios.post(`/dasm/lockNewB2BProductPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  editB2BMarketOrder(params) {
    return axios.post(`/dasm/editB2BMarketOrder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt 
      }
    });
  },

  b2bPurchaseOrderBackToForm(params) {
    return axios.post(`/dasm/b2bPurchaseOrderBackToForm`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  b2bPurchaseOrderBackToPrepare(params) {
    return axios.post(`/dasm/b2bPurchaseOrderBackToPrepare`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  copyReceiptToPrePare(params) {
    return axios.post(`/dasm/copyReceiptToPrePare`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  copyQuotationToPrePare(params) {
    return axios.post(`/dasm/copyQuotationToPrePare`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  copyReceiptToPrePareV2(params) {
    return axios.post(`/dasm/copyReceiptToPrePareV2`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  loaddatatoBuyhistory() {
    return axios.get(`/dasm/loaddatatoBuyhistory`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  }, 


  joinMarketBatchOrder(params) {
    return axios.post(`/dasm/joinMarketBatchOrder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelJoinMarketBatchOrder(params) {
    return axios.post(`/dasm/cancelJoinMarketBatchOrder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  productB2BSearch(params) {
    return axios.post(`/dasm/productB2BSearch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getSavedProductB2BSearch(params) {
    return axios.post(`/dasm/getSavedProductB2BSearch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getContractProducts(contractid, redate) {
    return axios.get(`/dasm/getContractProducts/${contractid}/${redate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // getContractProducts(contractid, redate) {
  //   return axios.get(`/dasm/getContractProducts/${contractid}/${redate}`, {
  //     headers: {
  //       Authorization: "Bearer " + store.getters.getJwt
  //     }
  //   });
  // },
  getContractProductsByType(contractid, redate, type) {
    return axios.get(`/dasm/getContractProductsByType/${contractid}/${redate}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getContractProductsBySearch(contractid, redate, type, search, producttype) {
    return axios.get(`/dasm/getContractProductsBySearch/${contractid}/${redate}/${type}/${search}/${producttype}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getContractProductList(contractid) {
    return axios.get(`/dasm/getContractProductList/${contractid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getContractProductListByContractType(contractid, b2busername, type) {
    return axios.get(`/dasm/getContractProductListByContractType/${contractid}/${b2busername}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getContractProductListByContractTypeAllOrder(startdate, enddate, status, company) {
    return axios.get(`/dasm/getContractProductListByContractTypeAllOrder/${startdate}/${enddate}/${status}/${company}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getInvoiceByDate(contractid, type, startdate, enddate) {
    return axios.get(`/dasm/getInvoiceByDate/${contractid}/${type}/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getInvoiceByBatch(contractid, batchid) {
    return axios.get(`/dasm/getInvoiceByBatch/${contractid}/${batchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  createBatchInoice(params) {
    return axios.post(`/dasm/createBatchInoice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelBatchInoice(params) {
    return axios.post(`/dasm/cancelBatchInoice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getReceiptBydate(contractid, type, startdate, enddate) {
    return axios.get(`/dasm/getReceiptBydate/${contractid}/${type}/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPaymentData(startdate, enddate, type) {
    return axios.get(`/dasm/getPaymentData/${startdate}/${enddate}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getB2BPaymentData(startdate, enddate) {
    return axios.get(`/dasm/getB2BPaymentData/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getB2bPaymentDataDetail(b2busername, startdate, enddate) {
    return axios.get(`/dasm/getB2bPaymentDataDetail/${b2busername}/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getQuotationDateList(startdate, enddate) {
    return axios.get(`/dasm/getQuotationDateList/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getallProfit(startdate, enddate,type, b2busername , productid, status) {
    return axios.get(`/dasm/getallProfit/${startdate}/${enddate}/${type}/${b2busername}/${productid}/${status}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getallProfitAllProductByProductSelected(startdate, enddate, b2busername, productid ) {
    return axios.get(`/dasm/getallProfitAllProductByProductSelected/${startdate}/${enddate}/${b2busername}/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getB2BAllProfit(startdate, enddate,type, b2busername , productid, status) {
    return axios.get(`/dasm/getB2BAllProfit/${startdate}/${enddate}/${type}/${b2busername}/${productid}/${status}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getPriceDailySetting(startdate, enddate,type, b2busername , productid, status) {
    return axios.get(`/dasm/getPriceDailySetting/${startdate}/${enddate}/${type}/${b2busername}/${productid}/${status}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      } 
    })
  }, 

  getPriceList_show(params) {
    return axios.post(`/dasm/getPriceList_show`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  doSetingPriceShow(params) {
    return axios.post(`/dasm/doSetingPriceShow`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  updatePriceShowOrder(params) {
    return axios.post(`/dasm/updatePriceShowOrder`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  setProductPrice(params) {
    return axios.post(`/dasm/setProductPrice`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  setProductPriceAll(params) {
    return axios.post(`/dasm/setProductPriceAll`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getProfitProductListByCustomer(params) {
    return axios.post(`/dasm/getProfitProductListByCustomer`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  doCustomerProductFilter(params) {
    return axios.post(`/dasm/doCustomerProductFilter`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  saveProfitB2BDetailProductPrice(params) {
    return axios.post(`/dasm/saveProfitB2BDetailProductPrice`, params, { 
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 

  getBuyHistoryData(contractid) {
    return axios.get(`/dasm/getBuyHistoryData/${contractid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  }, 
  
  saveBuyHistory(params) {
    return axios.post(`/dasm/saveBuyHistory`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getTopProductUsage(startdate, enddate, producttypeid) {
    return axios.get(`/dasm/getTopProductUsage/${startdate}/${enddate}/${producttypeid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getProductByVender(venderid) {
    return axios.get(`/dasm/getProductByVender/${venderid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getProductPrice(startdate, enddate, productid) {
    return axios.get(`/dasm/getProductPrice/${startdate}/${enddate}/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },
  
  getProductPriceHistory() {
    return axios.get(`/dasm/getProductPriceHistory`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getallMarketBatchStatus(startdate, enddate, route) {
    return axios.get(`/dasm/getallMarketBatchStatus/${startdate}/${enddate}/${route}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // getallMarketBatchDetail(batchid, username, orderby, search) {
  //   return axios.get(`/dasm/getallMarketBatchDetail/${batchid}/${username}/${orderby}/${search}`, {
  //     headers: {
  //       Authorization: "Bearer " + store.getters.getJwt
  //     }
  //   });
  // },

  getallMarketBatchDetail(params) {
    return axios.post(`/dasm/getallMarketBatchDetail`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketOrderDate(startdate, enddate) {
    return axios.get(`/dasm/getMarketOrderDate/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  joinOrderDetail(username, batchid, productid) {
    return axios.get(`/dasm/getJoinOrderDetail/${username}/${batchid}/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketOrderDetail(batchid, redate,marketid) {
    return axios.get(`/dasm/getMarketOrderDetail/${batchid}/${redate}/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveMarketforMarketBill(params) {
    return axios.post(`/dasm/saveMarketforMarketBill`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  asignMarket(params) {
    return axios.post(`/dasm/asignMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });  
  },

  searchProductMarket(params) {
    return axios.post(`/dasm/searchProductMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });  
  },

  asignMarket_temp(params) {
    return axios.post(`/dasm/asignMarket_temp`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelAsignMarket_temp(params) {
    return axios.post(`/dasm/cancelAsignMarket_temp`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  asignMarketByVender_temp(params) {
    return axios.post(`/dasm/asignMarketByVender_temp`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelPurchaserDetailByID(params) {
    return axios.post(`/dasm/cancelPurchaserDetailByID`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  confirmMarketforMarketBill(params) {
    return axios.post(`/dasm/confirmMarketforMarketBill`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  


  getUnSubmitPurchase(purchaseid) {
    return axios.get(`/dasm/getUnSubmitPurchase/${purchaseid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  
  },

  loadB2BProductRequirement(params) {
    return axios.post(`/dasm/loadB2BProductRequirement`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getContractDateProductList(status, contractid, type, txdate, purchaseid, productid) {
    return axios.get(`/dasm/getContractDateProductList/${status}/${contractid}/${type}/${txdate}/${purchaseid}/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeContractDateStatus(params) {
    return axios.post(`/dasm/changeContractDateStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  unSetContractProductAmount(params) {
    return axios.post(`/dasm/unSetContractProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  unSetContractProductsAmount(params) {
    return axios.post(`/dasm/unSetContractProductsAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  unSetContractPurchaseProductAmount(params) {
    return axios.post(`/dasm/unSetContractPurchaseProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  confirmContractProducts(params) {
    return axios.post(`/dasm/confirmContractProducts`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  cancelConfirmContractProducts(params) {
    return axios.post(`/dasm/cancelConfirmContractProducts`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getCustomerProductList(username, productid, startdate, enddate) {
    return axios.get(`/dasm/getCustomerProductList/${username}/${productid}/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getCustomerProductDetail(username, productid, startdate, enddate) {
    return axios.get(`/dasm/getCustomerProductDetail/${username}/${productid}/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductFixPriceList(username) {
    return axios.get(`/dasm/getProductFixPriceList/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveProductFixPrice(params) {
    return axios.post(`/dasm/saveProductFixPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getCustomerSell7Days(username) {
    return axios.get(`/dasm/getCustomerSell7Days/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getMarketShippingFee(marketid) {
    return axios.get(`/setting/getMarketShippingFee/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductPurchaser() {
    return axios.get(`/setting/getProductPurchaser`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  addProductPurchaser(params) {
    return axios.post(`/setting/addProductPurchaser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  removeProductPurchaser(params) {
    return axios.post(`/setting/removeProductPurchaser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  SwitchOrderService(params) {
    return axios.post(`/setting/SwitchOrderService`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveShippingdata(params) {
    return axios.post(`/setting/saveShippingdata`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductBuyVender(typeid) {
    return axios.get(`/setting/getProductBuyVender/${typeid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  addProductVender(params) {
    return axios.post(`/setting/addProductVender`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  removeProductVender(params) {
    return axios.post(`/setting/removeProductVender`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateShippingdata(params) {
    return axios.post(`/setting/updateShippingdata`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketsForStock(username) {
    return axios.get(`/setting/getMarketsForStock/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveMarket(params) {
    return axios.post(`/setting/saveMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarkets(username) {
    return axios.get(`/setting/getMarkets/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },



  updateMarket(params) {
    return axios.post(`/setting/updateMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketOpenCloseTime(marketid) {
    return axios.get(`/dasm/getMarketOpenCloseTime/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveMarketTime(params) {
    return axios.post(`/dasm/saveMarketTime`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketPlan(roleid, username) {
    return axios.get(`/setting/getMarketPlan/${roleid}/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getMarketOnline() {
    return axios.get(`/setting/getMarketOnline`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketOnlineOrder(marketid) {
    return axios.get(`/dasm/getMarketOnlineOrder/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  combineOrders(params) {
    return axios.post(`/dasm/combineOrders`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveTotal(params) {
    return axios.post(`/dasm/saveTotal`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  cancelTotal(params) {
    return axios.post(`/dasm/cancelTotal`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  completeCombineOrders(params) {
    return axios.post(`/dasm/completeCombineOrders`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelCombineOrders(params) {
    return axios.post(`/dasm/cancelCombineOrders`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelCombineOrdersForever(params) {
    return axios.post(`/dasm/cancelCombineOrdersForever`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getMarketOnlineOrderDetail(marketid) {
    return axios.get(`/dasm/getMarketOnlineOrderDetail/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketOnlineOrderCompleteDetail(marketid) {
    return axios.get(`/dasm/getMarketOnlineOrderCompleteDetail/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketOnlineOrderDetailbyPrepareid(prepareid) {
    return axios.get(`/dasm/getMarketOnlineOrderDetailbyPrepareid/${prepareid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketProductSub(marketid) {
    return axios.get(`/dasm/getMarketProductSub/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  takeProductOut(params) {
    return axios.post(`/dasm/takeProductOut`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  takeAllProductOut(params) {
    return axios.post(`/dasm/takeAllProductOut`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getProductByType(params) {
    return axios.post(`/dasm/getProductByType`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductSubByProduct(params) {
    return axios.post(`/dasm/getProductSubByProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  addProductSubToBuyList(params) {
    return axios.post(`/dasm/addProductSubToBuyList`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  removeProductFormBuyList(params) {
    return axios.post(`/dasm/removeProductFormBuyList`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveProductToBlackList(params) {
    return axios.post(`/dasm/saveProductToBlackList`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  doPaymentConfirm(params) {
    return axios.post(`/dasm/doPaymentConfirm`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  doPaymentConfirmByBatch(params) {
    return axios.post(`/dasm/doPaymentConfirmByBatch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  checkPreQuantity(params) {
    return axios.post(`/dasm/checkPreQuantity`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  removeProductsubFormPurchaseList(params) {
    return axios.post(`/dasm/removeProductsubFormPurchaseList`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  savePromotionPrice(params) {
    return axios.post(`/dasm/savePromotionPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // getStockHistory (params) {
  //   return axios.post(`/dasm/getStockHistory`, params, {
  //     headers: {
  //       Authorization: "Bearer " + store.getters.getJwt
  //     }
  //   });
  // },

  loadCheckProduct() {
    return axios.get(`/dasm/loadCheckProduct`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPriceModel (params) {
    return axios.post(`/dasm/getPriceModel`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  

  // saveStockOut(params) {
  //   return axios.post(`/dasm/saveStockOut`, params, {
  //     headers: {
  //       Authorization: "Bearer " + store.getters.getJwt
  //     }
  //   });
  // },

  saveAllLostProductPrice(params) {
    return axios.post(`/dasm/saveAllLostProductPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveProfitAllProductPrice(params) {
      return axios.post(`/dasm/saveProfitAllProductPrice`, params, {
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      });
    },
  
    saveProfitProductPrice(params) {
      return axios.post(`/dasm/saveProfitProductPrice`, params, {
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      });
    },

  changeQuotationDate(params) {
    return axios.post(`/dasm/changeQuotationDate`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  addQuantitytoBuylist(params) {
    return axios.post(`/dasm/addQuantitytoBuylist`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  takeAllProductIn(params) {
    return axios.post(`/dasm/takeAllProductIn`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductPriceByTypeForStock(params) {
    return axios.post(`/dasm/getProductPriceByTypeForStock`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductPriceByType(params) {
    return axios.post(`/dasm/getProductPriceByType`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  updateProductPrice(params) {
    return axios.post(`/dasm/updateProductPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  changeSataus(params) {
    return axios.post(`/setting/changeSataus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getB2BProductType() {
    return axios.get(`/setting/getB2BProductType`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getB2BMainProductList() {
    return axios.get(`/setting/getB2BMainProductList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductType() {
    return axios.get(`/setting/getProductType`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getProducts(marketid, redate) {
    return axios.get(`/setting/getProducts/${marketid}/${redate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  productSearch(params) {
    return axios.post(`/setting/productSearch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductsMarketPreQuotaDateCount(marketid) {
    return axios.get(`/setting/getProductsMarketPreQuotaDateCount/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  preMarketQuotalList(marketid) {
    return axios.get(`/setting/preMarketQuotalList/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  preMarketQuotaProductList(marketid, redate) {
    return axios.get(`/setting/preMarketQuotaProductList/${marketid}/${redate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getfarmerProduction(productionid) {
    return axios.get(`/dpp/getfarmerProduction/${productionid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  productionAction(params) {
    return axios.post(`/dpp/productionAction`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  productionReport(params) {
    return axios.post(`/dpp/productionReport`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductionReport(productionid) {
    return axios.get(`/dpp/getProductionReport/${productionid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPlantNoti(notitype, provinceid) {
    return axios.get(`/dpp/getPlantNoti/${notitype}/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveWeatherNoti(params) {
    return axios.post(`/dpp/saveWeatherNoti`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // START MARKET PURCHASER
  getMarketPurchaseList(username) {
    return axios.get(`/dasm/getMarketPurchaseList/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketPurchaseProductList(purchaserid,username, redate, batchid) {
    return axios.get(`/dasm/getMarketPurchaseProductList/${purchaserid}/${username}/${redate}/${batchid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  
  updatePurchaseMarketQuantity(params) {
    return axios.post(`/dasm/updatePurchaseMarketQuantity`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  confirmAllPurchaseMarket(params) {
    return axios.post(`/dasm/confirmAllPurchaseMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  
  purchaseProductSubList(purchsemarketid, productid, batchid, username) {
    return axios.get(`/dasm/purchaseProductSubList/${purchsemarketid}/${productid}/${batchid}/${username}`, {  
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  productUpdatePriceList(username) {
    return axios.get(`/dasm/productUpdatePriceList/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  savePrice(params) {
    return axios.post(`/dasm/savePrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clearPrice(params) {
    return axios.post(`/dasm/clearPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updatePrice(params) {
    return axios.post(`/dasm/updatePrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getPurchaserAccountBalance(username) {
    return axios.get(`/dasm/getPurchaserAccountBalance/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getBalanceStatement(username, startdate, enddate) {
    return axios.get(`/dasm/getBalanceStatement/${username}/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStatementDetail(statementid) {
    return axios.get(`/dasm/getStatementDetail/${statementid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelPurchaseMarketHistory(params) {
    return axios.post(`/dasm/cancelPurchaseMarketHistory`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  transferMarketBuyProduct(params) {
    return axios.post(`/dasm/transferMarketBuyProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  goToAnotherMarket(params) {
    return axios.post(`/dasm/goToAnotherMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveMarketAccount(params) {
    return axios.post(`/dasm/saveMarketAccount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  editMarketAccount(params) {
    return axios.post(`/dasm/editMarketAccount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  checkInMarket(params) {
    return axios.post(`/dasm/checkInMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // start help to create order
  getsubProduct(productid) {
    return axios.get(`/dasm/getsubProduct/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // end help to credate order


  // END MARKET PURCHASER

  // START ACCOUNT
  getPurchaserBalance() {
    return axios.get(`/account/getPurchaserBalance`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  topupMoney(params) {
    return axios.post(`/account/topupMoney`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStatementHitstory(owner) {
    return axios.get(`/account/getStatementHitstory/${owner}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStatementHitstoryByType(owner, typeid) {
    return axios.get(`/account/getStatementHitstoryByType/${owner}/${typeid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPurchasePaymentList(startdate, enddate) {
    return axios.get(`/account/getPurchasePaymentList/${startdate}/${enddate}`, {   
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }  
    });
  },

  getOkProductHistory(purchaserid, startdate, enddate) {
    return axios.get(`/account/getOkProductHistory/${purchaserid}/${startdate}/${enddate}`, {   
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getOkPurchaser() {
    return axios.get(`/account/getOkPurchaser`, {   
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockPurchasePaymentList(startdate, enddate) {
    return axios.get(`/account/getStockPurchasePaymentList/${startdate}/${enddate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveAccountDate(params) {
    return axios.post(`/account/saveAccountDate`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  // getStatementDetail(statementid) {
  //   return axios.get(`/account/getStatementDetail/${statementid}`, {
  //     headers: {
  //       Authorization: "Bearer " + store.getters.getJwt
  //     }
  //   });
  // },



  // END ACCOUNT

  // START Issue
  getSectionList() {
    return axios.get(`/issue/getSectionList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveIssue(params) {
    return axios.post(`/issue/saveIssue`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getIssueHistory(username) {
    return axios.get(`/issue/getIssueHistory/${username}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  // clinic

  getMarketProductionReport(proivinceid) {
    return axios.get(`/clinic/getMarketProductionReport/${proivinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketProductionFarmerList(marketid) {
    return axios.get(`/clinic/getMarketProductionFarmerList/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  productionClinicAdvice(params) {
    return axios.post(`/clinic/productionClinicAdvice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getB2BProductionReport(proivinceid) {
    return axios.get(`/clinic/getB2BProductionReport/${proivinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getB2BProductionFarmerList(provinceid) {
    return axios.get(`/clinic/getB2BProductionFarmerList/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicProducts(type) {
    return axios.get(`/clinic/getProducts/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
   
  getClinicStockProducts() {
    return axios.get(`/clinic/getStockProducts`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicProductsPriceType() {
    return axios.get(`/clinic/getProductsPriceType`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  setProductPriceType(params) {
    return axios.post(`/clinic/setProductPriceType`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  unSetProductPriceType(params) {
    return axios.post(`/clinic/unSetProductPriceType`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clinicProductTypeSelectedSearch_PriceType(params) {
    return axios.post(`/clinic/ProductTypeSelectedSearch_PriceType`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductPriceTypeList() {
    return axios.get(`/clinic/getProductPriceTypeList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicProducts_data(type) {
    return axios.get(`/clinic/getProducts_data/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  searchClinicProducts(params) {
    return axios.post(`/clinic/searchClinicProducts`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clinicProductTypeSelectedSearch(params) {
    return axios.post(`/clinic/ProductTypeSelectedSearch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  clinicProductTypeSelectedSearch_data(params) {
    return axios.post(`/clinic/ProductTypeSelectedSearch_data`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clinicStockProductTypeSelectedSearch(params) {
    return axios.post(`/clinic/clinicStockProductTypeSelectedSearch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clinicStockProductByGroup(params) {
    return axios.post(`/clinic/clinicStockProductByGroup`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  clinicProductHarvestSelectedSearch(params) {
    return axios.post(`/clinic/clinicProductHarvestSelectedSearch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicProductAllTypes() {
    return axios.get(`/clinic/getClinciProductAllTypes`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicStockProductGroup() {
    return axios.get(`/clinic/getClinicStockProductGroup`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getVenderProductType() {
    return axios.get(`/setting/getVenderProductType`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicProductTypes(farming) {
    return axios.get(`/clinic/getClinciProductTypes/${farming}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveProduct(params) {
    return axios.post(`/clinic/saveProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveStockProduct(params) {
    return axios.post(`/clinic/saveStockProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  

  updateProduct(params) {
    return axios.post(`/clinic/updateProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateStockProduct(params) {
    return axios.post(`/clinic/updateStockProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateProduct_data(params) {
    return axios.post(`/clinic/updateProduct_data`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  

  changeProductStatus(params) {
    return axios.post(`/clinic/changeProductStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveProductPriceType(params) {
    return axios.post(`/clinic/saveProductPriceType`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  
  updateProductPriceType(params) {
    return axios.post(`/clinic/updateProductPriceType`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clearProductData(params) {
    return axios.post(`/clinic/clearProductData`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clearProductData_sub(params) {
    return axios.post(`/clinic/clearProductData_sub`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  changeProductGrade(params) {
    return axios.post(`/clinic/changeProductGrade`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  addProductGrade(params) {
    return axios.post(`/clinic/addProductGrade`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  updateProductGrade(params) {
    return axios.post(`/clinic/updateProductGrade`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateProductGrade_data(params) {
    return axios.post(`/clinic/updateProductGrade_data`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductGrade(productid) {
    return axios.get(`/clinic/getProductGrade/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  
  getProductGrade_data(productid) {
    return axios.get(`/clinic/getProductGrade_data/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  saveClinicUser(params) {
    return axios.post(`/setting/saveClinicUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicUser() {
    return axios.get(`/setting/getClinicUser`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeUserClinicStatus(params) {
    return axios.post(`/setting/changeUserClinicStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateClinicUser(params) {
    return axios.post(`/setting/updateClinicUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveBranchofClinic(params) {
    return axios.post(`/setting/saveBranchofClinic`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getResponseClinicUser(roleid) {
    return axios.get(`/setting/getResponseClinicUser/${roleid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getBranchesofclinic() {
    return axios.get(`/setting/getBranchesofclinic`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateClinicBranch(params) {
    return axios.post(`/setting/updateClinicBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeBranchofClinicSataus(params) {
    return axios.post(`/setting/changeBranchofClinicSataus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getZoneProductivity(username, productid, type) {
    return axios.get(`/setting/getZoneProductivity/${username}/${productid}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  saveProductivity(params) {
    return axios.post(`/setting/saveProductivity`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getZoneSeed(username, productid, type) {
    return axios.get(`/setting/getZoneSeed/${username}/${productid}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveSeed(params) {
    return axios.post(`/setting/saveSeed`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getZoneRecommend(username, productid, type) {
    return axios.get(`/setting/getZoneRecommend/${username}/${productid}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveRecommend(params) {
    return axios.post(`/setting/saveRecommend`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicAllProductivity(params) {
    return axios.post(`/clinic/getAllProductivity`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getClinicProductGroupbyType() {
    return axios.get(`/clinic/getProductGroupByType`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },






  //ics

  saveICSUser(params) {
    return axios.post(`/setting/saveIcsUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getICSUser(roleid, parent) {
    return axios.get(`/setting/getIcsUser/${roleid}/${parent}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeUserICSStatus(params) {
    return axios.post(`/setting/changeUserIcsStatus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateIcsUser(params) {
    return axios.post(`/setting/updateIcsUser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProvincesofIcs(roleid) {
    return axios.get(`/setting/getProvincesofIcs/${roleid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getResponseIcsUser(roleid) {
    return axios.get(`/setting/getResponseIcsUser/${roleid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveBranchofIcs(params) {
    return axios.post(`/setting/saveBranchofIcs`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateIcsBranch(params) {
    return axios.post(`/setting/updateIcsBranch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeBranchofIcsSataus(params) {
    return axios.post(`/setting/changeBranchofIcsSataus`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveIcsDistrict(params) {
    return axios.post(`/setting/saveIcsDistrict`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getIcsDistrict(provinceid) {
    return axios.get(`/setting/getIcsDistrict/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  updateIcsDistrict(params) {
    return axios.post(`/setting/updateIcsDistrict`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveIcsGroup(params) {
    return axios.post(`/setting/saveIcsGroup`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getIcsGroup(districtid) {
    return axios.get(`/setting/getIcsGroup/${districtid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  updateIcsGroup(params) {
    return axios.post(`/setting/updateIcsGroup`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  // record
  getIcsRecordDistrict(provinceid) {
    return axios.get(`/ics/getIcsRecordDistrict/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getIcsRecordGroup(districtid) {
    return axios.get(`/ics/getIcsRecordGroup/${districtid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getIcsRecordFarm(groupid) {
    return axios.get(`/ics/getIcsRecordFarm/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getIcsProduction(farmid, type) {
    return axios.get(`/ics/getIcsProduction/${farmid}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getIcsProductionDetail(type, id) {
    return axios.get(`/ics/getIcsProductionDetail/${type}/${id}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveOARecordGroup(params) {
    return axios.post(`/ics/saveOARecordGroup`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveOARecordDistrict(params) {
    return axios.post(`/ics/saveOARecordDistrict`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveOARecordProvince(params) {
    return axios.post(`/ics/saveOARecordProvince`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getOARecordDetail(cropid) {
    return axios.get(`/ics/getOARecordDetail/${cropid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getAgrizoneDetail(type, id) {
    return axios.get(`/ics/getAgrizoneDetail/${type}/${id}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  // ics violation
  getViolationProvince() {
    return axios.get(`/ics/getViolationProvince`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getViolationDistrict(provinceid) {
    return axios.get(`/ics/getViolationDistrict/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getViolationGroup(districtid) {
    return axios.get(`/ics/getViolationGroup/${districtid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getViolationFarm(groupid) {
    return axios.get(`/ics/getViolationFarm/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getViolationProduction(farmid, type) {
    return axios.get(`/ics/getViolationProduction/${farmid}/${type}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getViolationDetail(farmid) {
    return axios.get(`/ics/getViolationDetail/${farmid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveViolationGroup(params) {
    return axios.post(`/ics/saveViolationGroup`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveViolationDistrict(params) {
    return axios.post(`/ics/saveViolationDistrict`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveViolationProvince(params) {
    return axios.post(`/ics/saveViolationProvince`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveViolationCenter(params) {
    return axios.post(`/ics/saveViolationCenter`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getVerificationFarm(groupid) {
    return axios.get(`/ics/getVerificationFarm/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getWaitVerificationFarm(groupid) {
    return axios.get(`/ics/getWaitVerificationFarm/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  addToCertification(params) {
    return axios.post(`/ics/addToCertification`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  cancelToCertification(params) {
    return axios.post(`/ics/cancelToCertification`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  confirmToCertification(params) {
    return axios.post(`/ics/confirmToCertification`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getWaitCertificationFarm(groupid) {
    return axios.get(`/ics/getWaitCertificationFarm/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getCertificationDetail(form) {
    return axios.get(`/ics/getCertificationDetail/${form}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getCertificationGroup(districtid) {
    return axios.get(`/ics/getCertificationGroup/${districtid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveCertificationDistrict(params) {
    return axios.post(`/ics/saveCertificationDistrict`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getCertificationDistrict(provinceid) {
    return axios.get(`/ics/getCertificationDistrict/${provinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveCertificationProvince(params) {
    return axios.post(`/ics/saveCertificationProvince`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getCertificationProvince() {
    return axios.get(`/ics/getCertificationProvince`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveCertificationCenter(params) {
    return axios.post(`/ics/saveCertificationCenter`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getGroupProductCheck() {
    return axios.get(`/ics/getGroupProductCheck`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getGroupProductCheckDetail(marketdate, farmid, ischecked) {
    return axios.get(`/ics/getGroupProductCheckDetail/${marketdate}/${farmid}/${ischecked}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  checkProductMarket(params) {
    return axios.post(`/ics/checkProductMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  // getIcsGroup(){
  //   return axios.get(`/setting/getIcsGroup`, {
  //     headers: { Authorization: "Bearer " + store.getters.getJwt }
  //   });
  // },

  // updateIcsGroup(params) {
  //   return axios.post(`/setting/updateIcsGroup`, params, {
  //     headers: { Authorization: "Bearer " + store.getters.getJwt }
  //   });
  // },
  // market checker

  getMarketSellBill(proivinceid) {
    return axios.get(`/marketchecker/getMarketSellBill/${proivinceid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketSellBillDetail(marketid) {
    return axios.get(`/marketchecker/getMarketSellBillDetail/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getMarketSellBillDetailDate(marketid, selldate) {
    return axios.get(`/marketchecker/getMarketSellBillDetailDate/${marketid}/${selldate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketRecommend() {
    return axios.get(`/makertmanager/getMarketRecommend`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getMarketProducts(marketid) {
    return axios.get(`/makertmanager/getMarketProducts/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  recomendProduct(params) {
    return axios.post(`/makertmanager/recomendProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getRecomendProduct(marketid) {
    return axios.get(`/makertmanager/getRecomendProduct/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  removeRecomendProduct(params) {
    return axios.post(`/makertmanager/removeRecomendProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  //

  resetPassword(params) {
    return axios.post(`/setting/resetPassword`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveProductAmount(params) {
    return axios.post(`/dasm/saveProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  unSetProductsAmount(params) {
    return axios.post(`/dasm/unSetProductsAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  unSetAllProducts(params) {
    return axios.post(`/dasm/unSetAllProducts`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  unSetProductAmount(params) {
    return axios.post(`/dasm/unSetProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  setProductToProduction(params) {
    return axios.post(`/dasm/setProductToProduction`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  setProductsToProduction(params) {
    return axios.post(`/dasm/setProductsToProduction`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  setAllProductsToProduction(params) {
    return axios.post(`/dasm/setAllProductsToProduction`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductToProduction(marketid) {
    return axios.get(`/dasm/getProductToProduction/${marketid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  getquotadatededtail(marketid, redate) {
    return axios.get(`/dasm/getquotadatededtail/${marketid}/${redate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProfitDetailList(purchaseid, redate, productid) {
    return axios.get(`/dasm/getProfitDetailList/${purchaseid}/${redate}/${productid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreOrderMarket() {
    return axios.get(`/dasm/getPreOrderMarket`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  savePreorderDate(params) {
    return axios.post(`/dasm/savePreorderDate`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreorderDate(sellerid) {
    return axios.get(`/dasm/getPreorderDate/${sellerid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreorderProducts(PREORDERDATEID) {
    return axios.get(`/dasm/getPreorderProducts/${PREORDERDATEID}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  preorderSearch(params) {
    return axios.post(`/dasm/preorderSearch`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  savePreOrderProductAmount(params) {
    return axios.post(`/dasm/savePreOrderProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveGotPreOrderProductAmount(params) {
    return axios.post(`/dasm/saveGotPreOrderProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  clearGotPreOrderProductAmount(params) {
    return axios.post(`/dasm/clearGotPreOrderProductAmount`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  settletoProductGrading(params) {
    return axios.post(`/dasm/settletoProductGrading`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  removeProductPreorderProduct(params) {
    return axios.post(`/dasm/removeProductPreorderProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductsDateDetail(PREORDERDATEID) {
    return axios.get(`/dasm/getProductsDateDetail/${PREORDERDATEID}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreORderDetail(preorderid, productsubid) {
    return axios.get(`/dasm/getPreORderDetail/${preorderid}/${productsubid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreorderProductDetail(preorderproductid) {
    return axios.get(`/dasm/getPreorderProductDetail/${preorderproductid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  savePreorderQuantityProvide(params) {
    return axios.post(`/dasm/savePreorderQuantityProvide`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  clearPreorderQuantityProvide(params) {
    return axios.post(`/dasm/clearPreorderQuantityProvide`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreorderProductAllDetail(preorderproductid) {
    return axios.get(`/dasm/getPreorderProductAllDetail/${preorderproductid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getproductforbuy(preorderproductid) {
    return axios.get(`/dasm/getproductforbuy/${preorderproductid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getcusttomernotgetanyproduct(preorderproductid) {
    return axios.get(`/dasm/getcusttomernotgetanyproduct/${preorderproductid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreorderCustomerDetail(preorderproductid) {
    return axios.get(`/dasm/getPreorderCustomerDetail/${preorderproductid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPreorderCustomerWhattoBuy(preorderproductid, customerid) {
    return axios.get(`/dasm/getPreorderCustomerWhattoBuy/${preorderproductid}/${customerid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  preorderInformCustomer(params) {
    return axios.post(`/dasm/preorderInformCustomer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },



  updatePreOrderProduct(params) {
    return axios.post(`/dasm/updatePreOrderProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  PrepareToOrder(params) {
    return axios.post(`/dasm/PrepareToOrder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  checkOrderPrepare(preorderdateid) {
    return axios.get(`/dasm/checkOrderPrepare/${preorderdateid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  PrepareToSingleOrder(params) {
    return axios.post(`/dasm/PrepareToSingleOrder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  CancelPreorder(params) {
    return axios.post(`/dasm/CancelPreorder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  processPreorderToOrder(params) {
    return axios.post(`/dasm/processPreorderToOrder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  processPreorderToSingleOrder(params) {
    return axios.post(`/dasm/processPreorderToSingleOrder`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  actionToMarketPlanForFarmer(params) {
    return axios.post(`/dpp/actionToMarketPlanForFarmer`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  savePaymentRequest(params) {
    return axios.post(`/dpp/savePaymentRequest`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPaymentRequest(branchid, productionid) {
    return axios.get(`/dpp/getPaymentRequest/${branchid}/${productionid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  // start stock
 
  
  getStockVenderList() {
    return axios.get(`/stock/getStockVenderList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockProductByVender(venderid) {
    return axios.get(`/stock/getStockProductByVender/${venderid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getStockProductByVenderV2(venderid) {
    return axios.get(`/stock/getStockProductByVenderV2/${venderid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getStockProductList() {
    return axios.get(`/stock/getStockProductList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getStockHistory (params) {
    return axios.post(`/stock/getStockHistory`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getAllStockProductList(params) {
    return axios.post(`/stock/getAllStockProductList`, params , {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  selectStockProduct(params) {
    return axios.post(`/stock/selectStockProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  searchOkProductKey(params) {
    return axios.post(`/stock/searchOkProductKey`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  mapOkStockProduct(params) {
    return axios.post(`/stock/mapOkStockProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelMapOkStockProduct(params) {
    return axios.post(`/stock/cancelMapOkStockProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  updateMainMappingMultiply(params) {
    return axios.post(`/stock/updateMainMappingMultiply`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  doUpdateMappingMultiply(params) {
    return axios.post(`/stock/doUpdateMappingMultiply`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  saveStockIn(params) {
    return axios.post(`/stock/saveStockIn`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductinStock(params) {
    return axios.post(`/stock/getProductinStock`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveStockOutWait(params) {
    return axios.post(`/stock/saveStockOut_Wait`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveProductDailyPrice(params) {
    return axios.post(`/stock/saveProductDailyPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  saveStockOut(params) {
    return axios.post(`/stock/saveStockOut`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveStockOutForPOS(params) {
    return axios.post(`/stock/saveStockOutForPOS`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductinStockUsage(params) {
    return axios.post(`/stock/getProductinStockUsage`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductStockCompare(params) {
    return axios.post(`/stock/getProductStockCompare`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockBuyDateList(params) {
    return axios.post(`/stock/getStockBuyDateList`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockBuyDateDetail(params) {
    return axios.post(`/stock/getStockBuyDateDetail`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getCompareMarketandStock(params) {
    return axios.post(`/stock/getCompareMarketandStock`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  reCalStockOut(params) {
    return axios.post(`/stock/reCalStockOut`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockSellReport(params) {
    return axios.post(`/stock/getStockSellReport`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getCheckStockByOKPurchase(params) {
    return axios.post(`/stock/getCheckStockByOKPurchase`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductStockBrokenHistory(params) {
    return axios.post(`/stock/getProductStockBrokenHistory`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductStockOutHistory(params) {
    return axios.post(`/stock/getProductStockOutHistory`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  checkWaitQuantity(params) {
    return axios.post(`/stock/checkWaitQuantity`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductStockOutHistoryByProduct(params) {
    return axios.post(`/stock/getProductStockOutHistoryByProduct`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelProductStockUsage(params) {
    return axios.post(`/stock/cancelProductStockUsage`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelProductStockOutWait(params) {
    return axios.post(`/stock/cancelProductStockOutWait`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  approveStockOutWait(params) {
    return axios.post(`/stock/approveStockOutWait`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getRemainProduct() {
    return axios.get(`/stock/getRemainProduct`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getStockProductDailyPrice() {
    return axios.get(`/stock/getStockProductDailyPrice`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  cancelProductStockIn(params) {
    return axios.post(`/stock/cancelProductStockIn`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getProductInStockSummary() {
    return axios.get(`/stock/getProductInStockSummary`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getProductInStockSummaryForOrder() {
    return axios.get(`/stock/getProductInStockSummaryForOrder`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },


  getStockVenderProduct(venderid) {
    return axios.get(`/stock/getStockVenderProduct/${venderid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getStockVenderProductV2(venderid) {
    return axios.get(`/stock/getStockVenderProductV2/${venderid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getFproductList() {
    return axios.get(`/stock/getFproductList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getFproductListForStock() {
    return axios.get(`/stock/getFproductListForStock`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  saveProductToStock(params) {
    return axios.post(`/stock/saveProductToStock`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getStockProductRemainSaved(txdate) {
    return axios.get(`/stock/getStockProductRemainSaved/${txdate}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  // getStockProductRemain() {
  //   return axios.get(`/stock/getStockProductRemain`, {
  //     headers: {
  //       Authorization: "Bearer " + store.getters.getJwt
  //     }
  //   })
  // },

  saveProductRemainToStock(params) {
    return axios.post(`/stock/saveProductRemainToStock`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getStockProductListForRequest() {
    return axios.get(`/stock/getStockProductListForRequest`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getStockProductListForRequestV2(groupid) {
    return axios.get(`/stock/getStockProductListForRequestV2/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  getStockProductListForCheck(groupid) {
    return axios.get(`/stock/getStockProductListForCheck/${groupid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    })
  },

  saveStockProductRequest(params) {
    return axios.post(`/stock/saveStockProductRequest`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveStockProductRequestV2(params) {
    return axios.post(`/stock/saveStockProductRequestV2`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },


  getPurchaserList() {
    return axios.get(`/stock/getPurchaserList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockVenderListForRequest() {
    return axios.get(`/stock/getStockVenderListForRequest`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  
  sendStockRequestToMarket(params) {
    return axios.post(`/stock/sendStockRequestToMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  sendStockRequestToMarketV2(params) {
    return axios.post(`/stock/sendStockRequestToMarketV2`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockMarketPurchaseList() {
    return axios.get(`/stock/getStockMarketPurchaseList`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  confirmStockToMarket(params) {
    return axios.post(`/stock/confirmStockToMarket`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  productToMorningCheck(params) {
    return axios.post(`/stock/productToMorningCheck`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  changeStockPurchaser(params) {
    return axios.post(`/stock/changeStockPurchaser`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getAskProductList(params) {
    return axios.post(`/stock/getAskProductList`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getPredictData(params) {
    return axios.post(`/stock/getPredictData`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockMarketDetail(purchaseid) {
    return axios.get(`/stock/getStockMarketDetail/${purchaseid}`, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveStockSellUnitPrice(params) {
    return axios.post(`/stock/saveStockSellUnitPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  saveStockSellUnitPriceAll(params) {
    return axios.post(`/stock/saveStockSellUnitPriceAll`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  cancelStockSellUnitPrice(params) {
    return axios.post(`/stock/cancelStockSellUnitPrice`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },
  cancelStockSellUnitPriceAll(params) {
    return axios.post(`/stock/cancelStockSellUnitPriceAll`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockbyuandsellresult(params) {
    return axios.post(`/stock/getStockbyuandsellresult`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockbyuandsellresultonlybystockin(params) {
    return axios.post(`/stock/getStockbyuandsellresultonlybystockin`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

  getStockbyuandsellresultonlybystockinDetail(params) {
    return axios.post(`/stock/getStockbyuandsellresultonlybystockinDetail`, params, {
      headers: {
        Authorization: "Bearer " + store.getters.getJwt
      }
    });
  },

 // end stock









};